import React from 'react';

const RenderPmIcon = (props) => {
  const { usePackingMaterials, currentPackingMaterials, handlePackingModal, currentSet } = props;

  const checkQuantity = () => {
    if (currentPackingMaterials === undefined || currentPackingMaterials.length === 0) {
      return false;
    }
    const items = [
      ...currentPackingMaterials.customMaterials,
      ...currentPackingMaterials.commonMaterials,
    ];

    return items.reduce((acc, o) => acc + parseInt(o.quantity), 0);
  };

  if (usePackingMaterials !== true) {
    return null;
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      {currentPackingMaterials && checkQuantity() ? (
        <div
          className=""
          style={{ cursor: 'pointer' }}
          title="Изменить упаковочные материалы"
          onClick={() => handlePackingModal(currentSet)}
        >
          <i className="fe-file-plus" style={{ color: 'green' }} />
        </div>
      ) : (
        <div
          className=""
          style={{ cursor: 'pointer' }}
          title="Добавить упаковочные материалы"
          onClick={() => handlePackingModal(currentSet)}
        >
          <i className="fe-file" />
        </div>
      )}
    </div>
  );
};

export default RenderPmIcon;
